export default __webpack_public_path__ + "static/media/EF-Unique.8fcfd459.png";